export * from './lib/language.service.module';

export { AccredibleLanguageService } from './lib/language.service';
export { AccredibleLanguageServiceMock } from './lib/language.service.mock';
export { AVAILABLE_LANGUAGES, getAvailableLanguages } from './lib/languages';
export { registerSupportedLocalesData } from './lib/register-languages';
export { CUSTOM_DATE_FORMATS, CustomDatePickerAdapter } from './lib/register-languages';
